module.exports = __webpack_public_path__ + "static/abc-property-managers-logo_white-d4b8d9365246a644c9cdb966727d637f.png";